module.exports = __webpack_public_path__ + "static/assets/d450e61af073265282cfdf43e7c61e96.gif";